export const CPFSortTypes = {
  DISTANCE: 'distance',
  RATING: 'rating',
  SUCCESS_RATE: 'success_rate',
  PRICE: 'price',
};
